"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Styles for use in the Connect To dialog.
var widgets_1 = require("@tableau/widgets");
var StyleFunctions_1 = require("./StyleFunctions");
var VizPortalStyles_1 = require("./VizPortalStyles");
exports.ConnectToButtonStyle = {
    float: 'right',
    marginBottom: '12px',
    marginTop: '12px',
};
exports.ConnectToSearchFieldContainerStyle = {
    width: '300px',
    float: 'left',
};
exports.ConnectToDropdown = StyleFunctions_1.cssClass('connectToDialogDropdownClass', {
    float: 'right',
});
exports.ConnectToDropdownButton = StyleFunctions_1.cssClass('connectToDialogDropdownButtonClass', {
    float: 'right',
    // Set a large enough width until tfsid904298 is fixed from shared widget
    width: '200px',
});
exports.ConnectToFilterPanelToggleButton = StyleFunctions_1.cssClass('connectToDialogFilterPanelToggleButtonClass', {
    display: 'flex',
    float: 'right',
    margin: '4px',
    width: '20px',
    height: '20px'
});
exports.ConnectToDropdownLabel = StyleFunctions_1.cssClass('connectToDialogDropdownLabelClass', __assign({}, VizPortalStyles_1.vizPortalFontStyle, { color: widgets_1.TabStyles.Typography.Color.Secondary, fontSize: widgets_1.TabStyles.Typography.Sizing.Default, lineHeight: '24px', float: 'right', paddingRight: widgets_1.TabStyles.Spacing.SmallSpace }));
exports.ConnectToDialogContainerForWeb = StyleFunctions_1.cssClass('connectToDialogContainerClass', {
    display: 'flex',
    flexFlow: 'column',
    height: '100%',
    width: '100%',
});
// Hybrid dialog needs a fixed height to generate the content inside it
exports.ConnectToDialogContainerForDesktop = StyleFunctions_1.cssClass('desktopConnectToDialogContainerClass', {
    display: 'flex',
    flexFlow: 'column',
    height: '478px',
    width: '100%',
});
exports.ConnectToDialogToolBar = StyleFunctions_1.cssClass('toolBarClass', {
    display: 'inline-block',
    width: '100%',
    paddingBottom: '16px',
});
exports.ConnectToDialogToolBarStackingRoot = StyleFunctions_1.cssClass('toolBarStackingRootClass', {
    position: 'absolute',
    // zIndex: 999 is a hack, but needed here to make the dropdown list show on top of the connect to dialog.
    // We cannot set the stackingRootId of the dropdown to the connect to dialog container,
    // becasuse it needs to be of position: absolute, which makes the element not take any space.
    // That will cause an UI issue in hybrid dialog of which the height is based on the content rendered inside it.
    zIndex: 999,
});
exports.ConnectToDialogDataGridStackingRoot = StyleFunctions_1.cssClass('dataGridStackingRootClass', {
    position: 'absolute',
    // zIndex: 999 is a hack, but needed here to make the DQW tooltip (or any other tooltips in the data grid)
    // show on top of the connect to dialog.
    // We cannot set the stackingRootId of the tooltip to the connect to dialog container,
    // becasuse it needs to be of position: absolute, which makes the element not take any space.
    // That will cause an UI issue in hybrid dialog of which the height is based on the content rendered inside it.
    zIndex: 999,
});
exports.ConnectToDialogGridContainerForWeb = StyleFunctions_1.cssClass('dataGridContainerClass', {
    display: 'flex',
    flex: 2,
    width: '100%',
});
// Hybrid dialog needs a fixed height to generate the content inside it
exports.ConnectToDialogGridContainerForDesktop = StyleFunctions_1.cssClass('desktopDataGridContainerClass', {
    display: 'flex',
    height: '400px',
    width: '100%',
});
exports.ConnectToDialogDescriptionContainer = StyleFunctions_1.cssClass('descriptionContainer', __assign({}, VizPortalStyles_1.vizPortalFontStyle, { color: widgets_1.TabStyles.Typography.Color.Primary, fontSize: '14px', paddingBottom: '12px', paddingTop: '12px', maxHeight: '100px', overflow: 'auto' }));
exports.ConnectToDialogRowDisabledWarningContainer = StyleFunctions_1.cssClass('rowDisabledWarningContainer', __assign({}, VizPortalStyles_1.vizPortalFontStyle, { color: widgets_1.TabStyles.Colors.AttentionDark, fontSize: widgets_1.TabStyles.Typography.Sizing.Default, paddingBottom: widgets_1.TabStyles.Spacing.DefaultSpace, paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace, overflow: 'auto' }));
exports.ConnectToButtonContainer = StyleFunctions_1.cssClass('connectToButtonContainerClass', {
    display: 'inline-block',
    height: '48px',
    width: '100%',
});
//# sourceMappingURL=ConnectToDialogStyles.js.map